import { useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getVoicePolicies from 'API/VoicePolicies/getVoicePolicies';

const useGetVoicePolicies = (setTableData, gridRef, colDefs) => {
    const query = useQuery({
        queryKey: ['VoicePolicies'],
        queryFn: getVoicePolicies,
        staleTime: 5 * 60 * 1000,
        retry: 2,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });

            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'name', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetVoicePolicies;
